<template>
  <v-app-bar app color="accent" dark>
    <v-toolbar-title
      class="text-no-wrap ma-15"
      min-width="300px"
      pd-4
      color="white"
    >
      <h3>Sam Coleman</h3>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn
      class="mx-2"
      href="https://www.linkedin.com/in/samuel-coleman-09412b1bb/"
      target="_blank"
      icon
    >
      <font-awesome-icon icon="fa-brands fa-linkedin" size="xl" />
    </v-btn>

    <v-btn
      class="mx-2"
      href="https://github.com/Samuel-Coleman-hub"
      target="_blank"
      icon
    >
      <font-awesome-icon icon="fa-brands fa-github" size="xl" />
    </v-btn>

    <v-btn
      class="mx-2"
      href="https://samcoleman.itch.io/"
      target="_blank"
      icon
    >
      <font-awesome-icon icon="fa-brands fa-itch-io" size="xl" />
    </v-btn>

    <v-btn
      class="mx-2"
      href="https://twitter.com/samc0leman"
      target="_blank"
      icon
    >
      <font-awesome-icon icon="fa-brands fa-twitter" size="xl" />
    </v-btn>

    <v-btn
      class="mx-2"
      v-on:click="SendEmail"
      target="_blank"
      icon

    >
      <font-awesome-icon icon="fa-solids fa-envelope" size="xl"/>
    </v-btn>
  </v-app-bar>
</template>
<script>
export default ({
  methods: {
    SendEmail: function (){
      window.location = "mailto:hello-samcoleman@outlook.com";
    }
  }
})
</script>
